import { useState } from "react";
import * as S from "./styles";
import { getPrefs, setEnabled, setVolume, play } from "../../utils/audio";
import { getLanguage, setLanguage } from "../../utils/language";

const Settings = ({ onClose }) => {
  const initial = getPrefs();
  const [enabled, setEnabledState] = useState(initial.enabled);
  const [volume, setVolumeState] = useState(initial.volume);
  const [lang, setLangState] = useState(getLanguage());

  const toggleSound = () => {
    const next = !enabled;
    setEnabledState(next);
    setEnabled(next);
    if (next) play("complete");
  };

  const changeVolume = (e) => {
    const v = parseFloat(e.target.value);
    setVolumeState(v);
    setVolume(v);
  };

  const pickLang = (next) => {
    setLangState(next);
    setLanguage(next);
  };

  const testSound = () => play("complete");

  return (
    <S.Backdrop onClick={onClose}>
      <S.Panel onClick={(e) => e.stopPropagation()}>
        <S.Title>SETTINGS</S.Title>
        <S.Row>
          <S.Label>SOUND</S.Label>
          <S.Toggle $on={enabled} onClick={toggleSound}>
            <span>{enabled ? "ON" : "OFF"}</span>
          </S.Toggle>
        </S.Row>
        <S.Row>
          <S.Label>VOLUME</S.Label>
          <S.Slider>
            <input
              type="range"
              min="0"
              max="1"
              step="0.05"
              value={volume}
              onChange={changeVolume}
              disabled={!enabled}
            />
            <S.SliderValue>{Math.round(volume * 100)}%</S.SliderValue>
          </S.Slider>
        </S.Row>
        <S.Row>
          <S.Label>TEST</S.Label>
          <S.TestButton onClick={testSound} disabled={!enabled}>
            ▶ PLAY
          </S.TestButton>
        </S.Row>
        <S.Row>
          <S.Label>LANGUAGE</S.Label>
          <S.LangGroup>
            <S.LangChip $on={lang === "en"} onClick={() => pickLang("en")}>EN</S.LangChip>
            <S.LangChip $on={lang === "tr"} onClick={() => pickLang("tr")}>TR</S.LangChip>
          </S.LangGroup>
        </S.Row>
        <S.Close onClick={onClose}>CLOSE</S.Close>
      </S.Panel>
    </S.Backdrop>
  );
};

export default Settings;
